import React from 'react';
import { Modal as MaterialModal } from '@material-ui/core';

import './ModalContainer.scss';
import Icon from 'src/components/Icon/Icon';
import classNames from 'classnames';

interface ModalContainerProps {
  children: any,
  // eslint-disable-next-line no-unused-vars
  handleClose: (e) => void,
  title: string,
  size?: string
}

function ModalContainer({ children, handleClose, title, size='medium' }: ModalContainerProps) {

  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ handleClose }
      className="modal"
    >
      <div className={
        classNames({
          'modal-container': true,
          'modal-container--medium': size === 'medium',
          'modal-container--wide': size === 'wide'
        })
      }
      >
        <div className="modal-launcher">
          <Icon icon="close" className="modal-container__close session__close" onClick={ handleClose } />
          <div className="modal-launcher__title">
            { title }
          </div>
          { children }
        </div>
      </div>
    </MaterialModal>
  );
}

export default ModalContainer;
